import { extendTheme } from "@chakra-ui/react";

const Theme = extendTheme({
  fontStyle: {
    heading: `'Poppins', sans-serif`,
    body: `'Poppins', sans-serif`,
    mono: `'Poppins', sans-serif`,
  },
  colors: {
    black: {
      300: "#262626",
      400: "#212226",
      900: "#000000",
    },
    white: {
      900: "#FFFFFF",
    },
    indigo: {
      900: "#130159",
    },
    navyBlue: {
      100: "#302884",
    },
    grey: {
      100: "#DCDCDC",
      200: "#E5E7EB",
    },
    purple: {
      100: "#BFBEDC",
      200: "#D9D6ED",
    },
    violet: {
      100: "#7464CE",
    },
  },
});

export default Theme;
